import { FC, ReactNode } from 'react';

import classes from './form.module.css';

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  className?: string;
  children: ReactNode;
}
export const Form: FC<FormProps> = ({ className, children, ...rest }) => (
  <form className={className || classes.form} {...rest}>
    {children}
  </form>
);
